module.exports = __webpack_public_path__ + "media/images/element/account-392b0ebc2c9c314e830d273cc3f09e8e.svg";